// Resize only the image CDNs already used by this catalog; uploaded media stays untouched.
export const ResponsiveImage = ({ src, alt, sizes = "(max-width: 767px) calc(100vw - 32px), (max-width: 1023px) 45vw, 400px", loading = "lazy", ...props }) => {
  let srcSet;
  try {
    const url = new URL(src);
    if (["images.pexels.com", "images.unsplash.com"].includes(url.hostname)) {
      srcSet = [320, 480, 640, 960, 1440, 1920].map((width) => {
        const variant = new URL(url);
        variant.searchParams.set("w", width);
        variant.searchParams.delete("h");
        variant.searchParams.delete("dpr");
        return `${variant.href} ${width}w`;
      }).join(", ");
    }
  } catch { /* Relative uploaded media uses the original source. */ }
  return <img src={src} alt={alt} srcSet={srcSet} sizes={srcSet ? sizes : undefined} loading={loading} decoding="async" {...props} />;
};
